import { isValidElement, PureComponent } from 'react';
import { injectIntl } from 'react-intl';
import { isFunction } from 'lodash';
import { Form } from 'semantic-ui-react';
import { getIn, ErrorMessage } from 'formik';

import { intl as intlUtils } from 'utils';

// COMPONENTS
import MaybeTranslation from 'components/MaybeTranslation';
import { ifInTestingMode } from 'utils/tests.utils';

const ErrorRenderer = (props) => {
  if (typeof props.children === 'object' && isValidElement(props.children)) {
    return props.children;
  }

  return <MaybeTranslation renderedValue={props.children} />;
};

export default function withFormField(Component) {
  class FormField extends PureComponent {
    static defaultProps = {
      autoComplete: 'off',
      disabled: false,
      error: false,
      fluid: true,
      label: undefined,
      labelChildren: undefined,
      placeholder: undefined,
      readOnly: false,
      ReadOnlyComponent: undefined,
      required: false,
      subFields: [],
      touched: false,
      wide: undefined,
      width: undefined,
    };

    getComponent = () => {
      const {
        children,
        // @ts-expect-error TS(2339): Property 'error' does not exist on type 'Readonly<... Remove this comment to see the full error message
        error,
        // @ts-expect-error TS(2339): Property 'fluid' does not exist on type 'Readonly<... Remove this comment to see the full error message
        fluid,
        // @ts-expect-error TS(2339): Property 'intl' does not exist on type 'Readonly<{... Remove this comment to see the full error message
        intl,
        // @ts-expect-error TS(2339): Property 'label' does not exist on type 'Readonly<... Remove this comment to see the full error message
        label,
        // @ts-expect-error TS(2339): Property 'labelChildren' does not exist on type 'R... Remove this comment to see the full error message
        labelChildren,
        // @ts-expect-error TS(2339): Property 'placeholder' does not exist on type 'Rea... Remove this comment to see the full error message
        placeholder,
        // @ts-expect-error TS(2339): Property 'ReadOnlyComponent' does not exist on typ... Remove this comment to see the full error message
        ReadOnlyComponent,
        // @ts-expect-error TS(2339): Property 'required' does not exist on type 'Readon... Remove this comment to see the full error message
        required,
        // @ts-expect-error TS(2339): Property 'subFields' does not exist on type 'Reado... Remove this comment to see the full error message
        subFields,
        // @ts-expect-error TS(2339): Property 'touched' does not exist on type 'Readonl... Remove this comment to see the full error message
        touched,
        // @ts-expect-error TS(2339): Property 'validator' does not exist on type 'Reado... Remove this comment to see the full error message
        validator,
        // @ts-expect-error TS(2339): Property 'wide' does not exist on type 'Readonly<{... Remove this comment to see the full error message
        wide,
        // @ts-expect-error TS(2339): Property 'width' does not exist on type 'Readonly<... Remove this comment to see the full error message
        width,
        ...rest
      } = this.props;

      const translatedPlaceholder = intlUtils.maybeTranslate(placeholder, intl);

      // @ts-expect-error TS(2339): Property 'readOnly' does not exist on type 'Readon... Remove this comment to see the full error message
      if (this.props.readOnly && typeof ReadOnlyComponent !== 'undefined') {
        return (
          <ReadOnlyComponent
            {...rest}
            // @ts-expect-error TS(2339): Property 'name' does not exist on type '{}'.
            id={rest.name}
            // @ts-expect-error TS(2339): Property 'name' does not exist on type '{}'.
            data-testid={ifInTestingMode(`formInput-${rest.name}--readOnly`)}
            placeholder={translatedPlaceholder}
          />
        );
      }

      return (
        <Component
          {...rest}
          // @ts-expect-error TS(2339): Property 'name' does not exist on type '{}'.
          id={rest.name}
          // @ts-expect-error TS(2339): Property 'name' does not exist on type '{}'.
          data-testid={ifInTestingMode(`formInput-${rest.name}`)}
          placeholder={translatedPlaceholder}
        >
          {children}
        </Component>
      );
    };

    getError = () => {
      // @ts-expect-error TS(2339): Property 'error' does not exist on type 'Readonly<... Remove this comment to see the full error message
      const { error, touched, subFields } = this.props;

      if (subFields.length) {
        if (touched) {
          const allFieldsTouched = subFields.reduce(
            (accumulator, subField) => accumulator && getIn(touched, subField),
            true
          );

          return allFieldsTouched ? error : undefined;
        }

        return undefined;
      }

      return error;
    };

    render() {
      // @ts-expect-error TS(2339): Property 'label' does not exist on type 'Readonly<... Remove this comment to see the full error message
      const { label, required, labelChildren, width, wide, name, className } = this.props;

      const error = this.getError();

      const resolvedChildren = isFunction(labelChildren) ? labelChildren(this.props) : labelChildren;

      let fieldClassName = wide ? 'wide' : '';

      if (className) {
        fieldClassName += ` ${className}`;
      }

      return (
        <Form.Field
          className={fieldClassName}
          error={error}
          // @ts-expect-error TS(2339): Property 'readOnly' does not exist on type 'Readon... Remove this comment to see the full error message
          required={required && !this.props.readOnly && !this.props.disabled}
          width={width}
          name={name}
        >
          {label && (
            <label htmlFor={name}>
              <MaybeTranslation renderedValue={label} />
              {resolvedChildren}
            </label>
          )}

          {this.getComponent()}

          {error && (
            <span className="message">
              <ErrorMessage
                name={name}
                data-testid={ifInTestingMode(`formInput-${name}-errorMessage`)}
                component={ErrorRenderer}
              />
            </span>
          )}
        </Form.Field>
      );
    }
  }

  // @ts-expect-error TS(2769): No overload matches this call.
  return injectIntl(FormField);
}
